<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        {{info.cname}}评价详情
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form :inline="true" :model="queryParams" label-width="70px">
        <el-form-item label="">
            <el-select
              v-model="queryParams.semester"
              clearable
              placeholder="选择学年学期"
              class="label"
            >
              <el-option
                v-for="item in semesterList"
                :key="item.schooleYearName + 'xq'"
                :label="item.schooleYearName"
                :value="item.schooleYearName"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="">
          <el-date-picker
            :picker-options="pickerOptions"
            v-model="queryParams.date"
            style="width:275px"
            type="week"
            :format="queryParams.startDate + '~' + queryParams.endDate + '第 WW 周'"
            placeholder="选择周"
        	  @change="customTimeSure"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="">
            <el-select
              v-model="queryParams.rating"
              clearable
              placeholder="选择星级"
              class="label"
            >
              <el-option
                v-for="item in ratingList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="" style="margin-left: 20px">
          <el-button type="primary" size="small" @click="searchFun()"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="evalUsername" label="评价人" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="evalTime" label="评价时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{dayjs(scope.row.evalTime).format('YYYY-MM-DD HH:mm')}}
            </template>
          </el-table-column>
          <el-table-column prop="evalUsertype" label="身份" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              {{userType[scope.row.evalUsertype]}}
            </template>
          </el-table-column>
          <el-table-column prop="evalUserClassname" label="班级" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="rating" label="评价星级" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="content" label="评价内容" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="del(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/schoolApi/index.js";
import dayjs from "dayjs";
import util from '@/utils/util.js';
export default {
  props: ["info", 'semesterList'],
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      queryParams: {
        semester: "",
        rating:'',
      },
      ratingList: [
        {id:'1',label:'1星'},
        {id:'2',label:'2星'},
        {id:'3',label:'3星'},
        {id:'4',label:'4星'},
        {id:'5',label:'5星'},
      ],
      tableData: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      userType:{
        '0':'学生',
        '1':'教师',
        '2':'家长',
      }
    };
  },
  watch: {
    "info.cid": function (n, o) {
      
      this.pageNum = 1;
      this.getDataList();
    },
  },
  created() {},
  methods: {
    dayjs,
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      let semester = this.semesterList.filter(e=>e.schooleYearName===this.queryParams.semester);
      let start = "", end = "";
      if(semester){
        start = semester.startDay || '';
        end = semester.endDay || '';
      }
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        cid: this.info.cid,
        startDay: start,
        endDay: end,
        rating: this.queryParams.rating,
      };
      let res = await api.schoolStatisticalOrgCourse(params);
      if (res.result === "000000") {
        this.tableData = res.data?.list || [];
        this.totalPage = res.data?.total || 0;
      }
    },
    
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    toIndex() {
      this.$emit("to-index");
    },
    // 自定义时间过滤
    customTimeSure() {
      let that = this.queryParams;
      if (that.date) {
        that.startDate = dayjs(that.date)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.date)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
    async del(item){
      let vm = this;
      util.handleCofirm('确定删除吗?', 'info',).then(async res => {
        let params = {
          id: item.id,
        };
        let res1 = await api.schoolStatisticalDelete(params);
        if(res1.result === '000000'){
          vm.$message.success('操作成功');
          vm.getDataList();
        }else{
          vm.$message.error('操作失败');
        }
      }).catch(err => {
				console.log('err', err) // cancel
			})
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-size: 20px;
      color: #000;
      max-width: 500px;
      text-align: center;
      // 省略号
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
